import { atom } from 'jotai';
import { loadable } from 'jotai/utils';
import request from 'lib/request';
import type { MissingSubtractBosResponse } from './types';

const missingSubtractBosBaseAtom = atom(async () => {
  const response = await request.get<MissingSubtractBosResponse>(
    '/admin/missing_subtract_bos'
  );
  if ('error' in response) {
    throw new Error(response.error);
  }
  return response;
});

export const missingSubtractBosLoadableAtom = loadable(
  missingSubtractBosBaseAtom
);
